import ChangeAspectRatioModal from './ChangeAspectRatioModal';
import connect from './connect';

export default connect(ChangeAspectRatioModal);
export { ChangeAspectRatioModalProps } from './ChangeAspectRatioModal';
